const devGlobal = globalThis as typeof globalThis & { __DEV__?: boolean };

if (typeof devGlobal.__DEV__ === 'undefined') {
  Object.defineProperty(globalThis, '__DEV__', {
    value: process.env.NODE_ENV !== 'production',
    configurable: true,
    writable: true,
  });
}

export {};
